import React, { useEffect, useState } from 'react';
import ConfirmDialog from '../ConfirmDialog';
import s from './Mileage.module.css';

// The question one date of a recurring trip asks (#554), as MMS asks it: a
// title, perhaps a sentence, two radios with the
// first chosen, and Cancel beside the action. Save of a changed date asks
// "Update Recurring Entries" — "This entry only" / "This and following
// entries", then Update; Delete asks "Delete Mileage" with MMS's sentence —
// "Only this entry" / "This entry and all future entries", then Delete.
// The words are core/src/mileage.rs's.
//
// The first radio is the default because it is MMS's, and because the cost
// of applying too little is one more edit while the cost of too much is a
// rewritten log — the calendar's `RecurringScopeDialog` argues the same.
export default function MileageChoiceDialog({
  open, title, message = null, choices, confirmLabel, cancelLabel, onConfirm, onCancel,
}) {
  const [choice, setChoice] = useState(choices[0][0]);
  // Asked afresh each time it opens.
  useEffect(() => { if (open) setChoice(choices[0][0]); }, [open, choices]);

  return (
    <ConfirmDialog
      open={open}
      title={title}
      message={(
        <span>
          {message ? <span className={s.choiceMessage}>{message}</span> : null}
          {choices.map(([value, label]) => (
            <label key={value} className={s.checkRow}>
              <input type="radio" name="mileage-choice" checked={choice === value} onChange={() => setChoice(value)} />
              <span>{label}</span>
            </label>
          ))}
        </span>
      )}
      confirmLabel={confirmLabel}
      discardLabel={cancelLabel}
      cancelLabel={null}
      onConfirm={() => onConfirm(choice)}
      onDiscard={onCancel}
      onCancel={onCancel}
    />
  );
}
